import { _ as _call_super } from "@swc/helpers/_/_call_super";
import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _inherits } from "@swc/helpers/_/_inherits";
import { _ as _instanceof } from "@swc/helpers/_/_instanceof";
import { MissingFormatRange } from './internal/MissingFormat.js';
import { createNumberFormat, NumberAutoScaleFormat } from './internal/NumberAutoScaleFormat.js';
/**
 * Proxy for {@link Intl.NumberFormat} that formats `null` and `undefined` as missing values.
 */ export var NumberMissingFormat = /*#__PURE__*/ function(MissingFormatRange) {
    "use strict";
    _inherits(NumberMissingFormat, MissingFormatRange);
    function NumberMissingFormat(localesOrFormat, options) {
        _class_call_check(this, NumberMissingFormat);
        return _call_super(this, NumberMissingFormat, [
            _instanceof(localesOrFormat, Intl.NumberFormat) || _instanceof(localesOrFormat, NumberAutoScaleFormat) ? localesOrFormat : createNumberFormat(localesOrFormat, options),
            options
        ]);
    }
    return NumberMissingFormat;
}(MissingFormatRange);

//# sourceMappingURL=NumberMissingFormat.js.map